import React, { forwardRef } from 'react'

type FileInputProps = {
  onFileInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const FileInput = forwardRef<HTMLInputElement, FileInputProps>(
  ({ onFileInputChange }, inputRef) => {
  return (
      <input
        hidden
        ref={inputRef}
        type="file"
        accept=".jpg,.jpeg"
        onChange={onFileInputChange}
        multiple
      />
    );
  }
)

export default FileInput